import api from './api';
import type {
  NotificationChannel,
  CreateNotificationChannelDto,
  UpdateNotificationChannelDto,
  NotificationChannelType,
} from '../types/notifications';

// Notification Channels API
export const notificationChannelsApi = {
  // Get user's notification channels
  getUserChannels: async (filters?: {
    channel_type?: NotificationChannelType;
    is_active?: boolean;
    is_verified?: boolean;
  }): Promise<{ channels: NotificationChannel[]; count: number }> => {
    const params = new URLSearchParams();
    
    if (filters?.channel_type) {
      params.append('channel_type', filters.channel_type);
    }
    if (filters?.is_active !== undefined) {
      params.append('is_active', String(filters.is_active));
    }
    if (filters?.is_verified !== undefined) {
      params.append('is_verified', String(filters.is_verified));
    }
    
    const response = await api.get(`/api/notification-channels?${params}`);
    return response.data;
  },

  // Create a new channel
  createChannel: async (data: CreateNotificationChannelDto): Promise<{
    message: string;
    channel: NotificationChannel;
  }> => {
    const response = await api.post('/api/notification-channels', data);
    return response.data;
  },

  // Update a channel
  updateChannel: async (id: string, data: UpdateNotificationChannelDto): Promise<{
    message: string;
    channel: NotificationChannel;
  }> => {
    const response = await api.put(`/api/notification-channels/${id}`, data);
    return response.data;
  },

  // Verify a channel
  verifyChannel: async (id: string, verificationCode?: string): Promise<{
    message: string;
  }> => {
    const response = await api.post(`/api/notification-channels/${id}/verify`, {
      verification_code: verificationCode,
    });
    return response.data;
  },

  // Test a channel
  testChannel: async (id: string): Promise<{
    message: string;
    channel_type: NotificationChannelType;
    channel_value: string;
  }> => {
    const response = await api.post(`/api/notification-channels/${id}/test`);
    return response.data;
  },

  // Delete a channel
  deleteChannel: async (id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/api/notification-channels/${id}`);
    return response.data;
  },
};
